import React, { createContext, useContext, useState } from 'react';

const ZoneContext = createContext(null);

const ZONE_LABELS = {
  'finishing-zone': 'Finishing Zone',
  'assembly-zone': 'Assembly Zone',
  'packaging-zone': 'Packaging Zone',
};

export function ZoneProvider({ children }) {
  const [selectedZone, setSelectedZone] = useState('finishing-zone');

  return (
    <ZoneContext.Provider value={{ selectedZone, setSelectedZone, ZONE_LABELS }}>
      {children}
    </ZoneContext.Provider>
  );
}

export function useZone() {
  const context = useContext(ZoneContext);
  if (!context) {
    throw new Error('useZone must be used within a ZoneProvider');
  }
  return context;
}
